<template>
    <div class="sweep">
        <div style="float: left">
            <span>状态:</span>
            <el-select :value="queryParams.status" @change="handleSweepStatusChange($event)" placeholder="状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="创建" value="0"></el-option>
                <el-option label="正在执行中" value="1"></el-option>
                <el-option label="失败" value="2"></el-option>
                <el-option label="完成" value="3"></el-option>
                <el-option label="没有找到ERC20配置信息" value="4"></el-option>
            </el-select>
        </div>
        <div class="preview-opration">
            <el-button style="margin-left: 30px" icon="el-icon-plus" type="danger" @click="openCreateSweepDialog">新增
            </el-button>
        </div>
        <div style="width: 100%;float: left;margin-top: 10px">
            <el-input placeholder="SWEEP_ERC20_GAS_LIMIT_RATIO" v-model="gasLimitRatio"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="updateGasLimitRatio">修改</el-button>
            <span style="color: red">（SWEEP_ERC20_GAS_LIMIT_RATIO比列值，填整数）</span>
        </div>
        <div class="sweep-list">
            <el-table class="sweep-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="coinType" label="币种类型"></el-table-column>
                <el-table-column prop="userAddress" label="地址" show-overflow-tooltip></el-table-column>
                <el-table-column prop="addressType" label="地址类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="hash" label="hash" show-overflow-tooltip></el-table-column>
                <el-table-column prop="config" label="配置字符串" show-overflow-tooltip></el-table-column>
                <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span>{{scope.row.status | formatStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="retryRecord(scope.row.id)"
                                   v-if="scope.row.status == 2 || scope.row.status == 4">重试
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="增加" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="120px">
                <el-form-item label="币种">
                    <el-autocomplete class="inline-input"
                                     v-model="addData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种"
                                     @select="handleSelect"
                                     @keyup.native.enter="handleSearch">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="地址">
                    <div id="address-list" style="margin-left: 0px">
                        <div class="address-model" v-for="item in addressList" :key="item.id">
                            <el-input style="width: 50%;margin-top: 5px;margin-bottom: 5px"
                                      placeholder="请输入地址" v-model="item.value"></el-input><!--@blur="formatCheck"-->
                            <el-select style="width:95px;margin-left:10px" v-model="item.selectvalue" placeholder="请选择">
                                <el-option label="合约" value="0"> </el-option>
                                <el-option label="普通" value="1"> </el-option>
                            </el-select>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       @click="deleteAddressFrom(item.id)"></el-button>
                            <span v-if="item.visible" style="color: red;margin-left: 30px">* 格式不正确</span>
                        </div>
                    </div>
                    <el-button style="margin-left: 0px;margin-top: 10px" icon="el-icon-plus" type="primary" @click="addAddressFrom"></el-button>
                </el-form-item>
                <el-form-item label="合约地址">
                    <el-input placeholder="请输入合约地址" v-model="addData.config.contractAddress" style="width: 80%"></el-input>
                </el-form-item>
                <el-form-item label="API Precision">
                    <el-input placeholder="API Precision" v-model="addData.config.apiPrecision" style="width: 80%"></el-input>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addSweepRecord">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'Sweep',
        data() {
            return {
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    status: "",
                },
                gasLimitRatio: 0,
                dialogVisible: false, //对话框是否显示
                loading: false,
                addData: {
                    coinType: "",
                    addressList: [ {address:"",addressType:''}],
                    config: {coinType: "", contractAddress: "", apiPrecision: ""}
                },
                coinTypes: [],
                addressList: [{
                    id: (new Date()).getTime(),
                    value: "",
                    selectvalue:'',
                    visible: false
                }],
                valueone:''
            };
        },
        filters: {
            formatStatus(state) {
                switch (state) {
                    case 0:
                        return "创建";
                    case 1:
                        return "正在执行中";
                    case 2:
                        return "失败";
                    case 3:
                        return "完成";
                    case 4:
                        return "没有找到ERC20配置信息";
                }
            }
        },
        methods: {
            getAllRecord(query) {
                api.getAllRecord(query).then(({data}) => {
                    data.list.map(item=>{
                        if(item.addressType == 0){
                            item.addressType = '合约'
                        }else if(item.addressType == 1){
                            item.addressType = '普通'
                        }
                    })
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            sweepGasRatioConfig() {
                api.sweepGasRatioConfig().then(({data}) => {
                    this.gasLimitRatio = data;
                });
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getAllRecord(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getAllRecord(this.queryParams);
            },
            handleSweepStatusChange(status) {
                this.queryParams.status = status;
                this.getAllRecord(this.queryParams);
            },
            openCreateSweepDialog() {
                this.getAllSupportCoin();
                this.dialogVisible = true;
            },
            updateGasLimitRatio() {
                this.$confirm('确认修改吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateSweepGasRatioConfig({gasRatio: this.gasLimitRatio}).then(({data}) => {
                        this.$message.success('修改成功!');
                        this.sweepGasRatioConfig();
                    });
                }).catch(() => {
                });
            },
            retryRecord(id) {
                this.$confirm('确认重试吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.retryRecord({id: id}).then(({data}) => {
                        this.$message.success('操作成功!');
                        this.getAllRecord(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            formatCheck() {
                let result = true;
                for (let i = 0; i < this.addressList.length; i++) {
                    if (!/^(0x|0X){1}[0-9a-fA-F]{40}$/.test(this.addressList[i].value.trim())) {
                        this.addressList[i].visible = true;
                        result = false;
                    } else {
                        this.addressList[i].visible = false;
                    }
                }
                return result;
            },
            addSweepRecord() {
                this.addData.addressList = [];
                if (this.addData.coinType == "") {
                    this.$message.error('请选择币种');
                    return;
                }
                // if (!this.formatCheck()) {
                //     this.$message.error('地址格式不正确！');
                //     return;
                // }
                if(this.addressList[0].selectvalue.length ==0){
                    this.$message.error('请选择地址类型');
                    return;
                }
                for (let i = 0; i < this.addressList.length; i++) {
                    if (this.addressList[i].value.trim() != "") {
                        this.addData.addressList.push({address:this.addressList[i].value.trim(),addressType:this.addressList[i].selectvalue});
                    }
                }
                if (this.addData.addressList.length == 0) {
                    this.$message.error('请添加地址');
                    return;
                }
                // if (this.addData.config.contractAddress == "") {
                //     this.$message.error('请填入合约地址');
                //     return;
                // }
                // if (this.addData.config.apiPrecision == "") {
                //     this.$message.error('请填入API Precision');
                //     return;
                // }
                this.loading = true;
                this.addData.config.coinType = this.addData.coinType;
                api.addRecord(this.addData).then(({data}) => {
                    this.$message.success('添加成功!');
                    this.getAllRecord(this.queryParams);
                    this.dialogVisible = false;
                    this.loading = false;
                });
            },
            addAddressFrom() {
                this.addressList.push({
                    id: (new Date()).getTime(),
                    value: "",
                    selectvalue:'',
                    visible: false
                });
            },
            deleteAddressFrom(id) {
                if (this.addressList.length == 1) {
                    this.$message("至少得有一个地址");
                    return;
                }
                for (let i = 0; i < this.addressList.length; i++) {
                    if (this.addressList[i].id == id) {
                        this.addressList.splice(i, 1);
                        return;
                    }
                }
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.coinType = '';
            },
            handleSearch() {

            },
            handleSelect() {
            },
            clearData() {
                this.addData = {
                    coinType: "",
                    addressList: [],
                    config: {coinType: "", contractAddress: "", apiPrecision: ""}
                }
                this.coinTypes = []
                this.addressList = [{
                    id: (new Date()).getTime(),
                    value: "",
                    visible: false
                }]
                this.loading = false;
            }
        },
        created() {
            this.getAllRecord(this.queryParams);
            this.sweepGasRatioConfig();
        }
    };
</script>

<style lang="less" scoped>
    .sweep {
        .preview-opration {
            float: right;
        }

        .sweep-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .sweep-table {
                margin-top: 30px;
            }
        }
    }
</style>

